import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-area pt-120 mb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = { class: "form-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "form-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Admin Log In Here!"),
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-12" }
const _hoisted_9 = { class: "form-inner mb-25" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email*", -1)
const _hoisted_11 = { class: "input-area" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/email-2.svg",
  alt: ""
}, null, -1)
const _hoisted_13 = { class: "col-lg-12" }
const _hoisted_14 = { class: "form-inner" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Password*", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-eye-slash",
  id: "togglePassword"
}, null, -1)
const _hoisted_17 = { class: "col-lg-12 mt-4" }
const _hoisted_18 = { class: "form-inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("form", null, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.email) = $event)),
                          type: "email",
                          id: "email",
                          name: "email",
                          placeholder: "info@example.com"
                        }, null, 512), [
                          [_vModelText, _ctx.user.email]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.password) = $event)),
                        type: "password",
                        name: "password",
                        id: "password",
                        placeholder: "Password"
                      }, null, 512), [
                        [_vModelText, _ctx.user.password]
                      ]),
                      _hoisted_16
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args))),
                        class: "primry-btn-2",
                        type: "button"
                      }, "LogIn")
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}